import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import PropertySection from '@/components/PropertySection';
import HotspotMap from '@/components/HotspotMap';
import BedroomCarousel from '@/components/BedroomCarousel';
import InteractiveLocationMap from '@/components/InteractiveLocationMap';
import ReviewsSection from '@/components/ReviewsSection';
import BookingSection from '@/components/BookingSection';
import RegionSection from '@/components/RegionSection';
import ActivitiesSection from '@/components/ActivitiesSection';
import FaqSection from '@/components/FaqSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import StickyBookingBar from '@/components/StickyBookingBar';
const Index = () => {
  return <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <HeroSection />
        
        {/* Property Section */}
        <section id="maison" className="py-16 bg-white">
          <div className="container-custom">
            <PropertySection />
          </div>
        </section>
        
        {/* Hotspot Map Section - Plan de la maison */}
        <section className="py-16 bg-gray-50">
          <div className="container-custom">
            <HotspotMap />
          </div>
        </section>
        
        {/* Bedrooms Section - Où vous dormirez */}
        <section className="py-16 bg-gray-50">
          <div className="container-custom max-w-5xl mx-auto px-4 sm:px-6">
            <BedroomCarousel />
          </div>
        </section>
        
        {/* Booking Section */}
        <section id="tarifs" className="py-16 bg-gray-50">
          <div className="container-custom">
            <BookingSection />
          </div>
        </section>

        {/* Reviews Section */}
        <section className="py-8 md:py-16 bg-gray-50">
          <div className="container-custom">
            <ReviewsSection />
          </div>
        </section>

        {/* Activities Section */}
        <section id="activites" className="py-16 bg-white">
          <div className="container-custom">
            <ActivitiesSection />
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 bg-gray-50">
          <div className="container-custom">
            <FaqSection />
          </div>
        </section>

        {/* Region Section */}
        <section id="region" className="py-16 bg-white pb-[10px]">
          <div className="container-custom">
            <RegionSection />
          </div>
        </section>

        {/* Location Map Section - Où se situe le logement */}
        <section className="bg-white pb-[65px] pt-[5px] py-[10px]">
          <div className="container-custom max-w-5xl mx-auto px-4 sm:px-6">
            <InteractiveLocationMap locationName="Plouguerneau, Bretagne, France" description="Ty Gwennili est située à Plouguerneau, à moins de 400 mètres de la plage et à proximité de tous commerces. Idéalement située pour découvrir les charmes du Finistère Sud." />
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="bg-gray-50">
          <div className="container-custom py-[29px]">
            <ContactSection />
          </div>
        </section>
      </main>
      
      <Footer />
      
      {/* Sticky Booking Bar */}
      <StickyBookingBar />
    </div>;
};
export default Index;